import { render, staticRenderFns } from "./notifications-database-export-complete.vue?vue&type=template&id=13df5b3d&"
import script from "./notifications-database-export-complete.vue?vue&type=script&lang=js&"
export * from "./notifications-database-export-complete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports